import { createAction, props } from '@ngrx/store';

export const emailOrdersExport = createAction('[Orders] Email Orders Data Export');

export const emailOrdersExportSuccess = createAction('[Orders] Email Orders Data Export Success');

export const emailOrdersExportFailure = createAction(
  '[Orders] Email Orders Data Export Failure',
  props<{ error: any }>(),
);
